function Contact(props) {
    return (
        <section className="columns content-card">
            <p>yanm2 (at) cs (dot) stanford (dot) edu</p>
        </section>
    )
}

export default Contact;
